import { getLuminance } from 'polished';

import { token } from '@atlaskit/tokens';

export const readableTextColor = (color: string): string => {
	return getLuminance(color) > 0.5 ? token('color.text') : token('color.text.inverse');
};
